import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';

interface BrandPopupProps {
  popupOpen: boolean;
  setPopupOpen: (open: boolean) => void;
  onRegister: (brandData: { name: string }) => void;
}

const BrandPopup: React.FC<BrandPopupProps> = ({
  popupOpen,
  setPopupOpen,
  onRegister,
}) => {
  const validationSchema = Yup.object({
    name: Yup.string()
      .min(2, 'El nombre debe tener al menos 2 caracteres')
      .required('El nombre de la marca es obligatorio'),
  });

  const formik = useFormik({
    initialValues: {
      id: 0,
      name: '',
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      onRegister(values);
      resetForm();
      setPopupOpen(false);
    },
  });

  useEffect(() => {
    if (!popupOpen) {
      formik.resetForm();
    }
  }, [popupOpen]);

  return (
    <FormModal
      isOpen={popupOpen}
      onClose={() => setPopupOpen(false)}
      title="Agregar Marca"
      maxWidth="max-w-md"
    >
      <form
        onSubmit={formik.handleSubmit}
        className="mt-4"
      >
        <InputField
          label="Nombre"
          name="name"
          type="text"
          placeholder="Ingrese nombre de la marca"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={
            formik.touched.name &&
            formik.errors.name
              ? formik.errors.name
              : undefined
          }
          iconKey="edit"
        />

        <button
          type="submit"
          className="w-full rounded bg-primary px-4 py-2 font-medium text-white hover:bg-opacity-90"
        >
          Guardar Marca
        </button>
      </form>
    </FormModal>
  );
};

export default BrandPopup;